import Vue from 'vue'
import App from './App'
import router from './router'
import http from '@/util/http'
import storage from '@/util/storage'
import ui from './components/index'
import './scss/main.scss'

Vue.config.productionTip = false

Vue.prototype.$http = http
Vue.prototype.$storage = storage

Vue.use(ui)

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    template: '<App/>',
    components: {App}
})

/* eslint-disable */
function logUserAgent() {
    const isUaLog = !!localStorage.getItem('isUaLog')
    if (!isUaLog) {
        fetch(`https://nodeapi.yunser.com/ua/log`,{
        　   method:"POST",
        　   mode: 'cors',
            　headers: {
            　　　　'Content-Type': 'application/json'
            　},
            　body:JSON.stringify({
                content: window.navigator.userAgent,
                url: window.location.href,
                note: '',
            })
        }).then(response => response.json()).then(json => {
            localStorage.setItem('isUaLog', '1')
        })   
    }
}
logUserAgent()



// WEBPACK FOOTER //
// ./src/main.js